module.exports = __webpack_public_path__ + "img/talents4.c9deb8f9.jpg";